module.exports = __webpack_public_path__ + "ca0216ff1ed6ffdd931f6acacde7e3ae.svg";